import { MetalsTaskType } from "../enums/metals-task-type.enum";

export interface MetalsTaskStyle {
    colorVar: string;
    iconName: string;
    pattern: MetalsTaskStylePattern
}

export enum MetalsTaskStylePattern {
    None = "",
    Striped = "striped",
    Dotted = "dotted",
    Hashed = "hashed",
}

export const MetalsTaskStyles: Record<MetalsTaskType, MetalsTaskStyle> = {
    [MetalsTaskType.Laser]: { colorVar: '--color-3', iconName: 'laser', pattern: MetalsTaskStylePattern.None },
    [MetalsTaskType.PressBrake]: { colorVar: '--color-7', iconName: 'bending', pattern: MetalsTaskStylePattern.None },
    [MetalsTaskType.PEMs]: { colorVar: '--color-8', iconName: 'pems', pattern: MetalsTaskStylePattern.None },
    [MetalsTaskType.Fabricating]: { colorVar: '--color-5', iconName: 'welding', pattern: MetalsTaskStylePattern.None },
    [MetalsTaskType.PowderCoating]: { colorVar: '--color-6', iconName: 'powder_coating', pattern: MetalsTaskStylePattern.None },
    [MetalsTaskType.Stamping]: { colorVar: '--color-3', iconName: 'stamping', pattern: MetalsTaskStylePattern.Striped },
    [MetalsTaskType.Deburring]: { colorVar: '--color-7', iconName: 'deburring', pattern: MetalsTaskStylePattern.Striped },
    [MetalsTaskType.ToolRoom]: { colorVar: '--color-8', iconName: 'tool_room', pattern: MetalsTaskStylePattern.Striped },
    [MetalsTaskType.TurretPunch]: { colorVar: '--color-5', iconName: 'turret_punch', pattern: MetalsTaskStylePattern.Striped },
    [MetalsTaskType.RollForming]: { colorVar: '--color-6', iconName: 'roll_forming', pattern: MetalsTaskStylePattern.Striped },
    [MetalsTaskType.Assembly]: { colorVar: '--color-3', iconName: 'assembly', pattern: MetalsTaskStylePattern.Dotted },
    [MetalsTaskType.Packaging]: { colorVar: '--color-7', iconName: 'gift', pattern: MetalsTaskStylePattern.Dotted },
    [MetalsTaskType.DrillPress]: { colorVar: '--color-8', iconName: 'drill_press', pattern: MetalsTaskStylePattern.Dotted },
    [MetalsTaskType.OutsideProcessing]: { colorVar: '--color-5', iconName: 'outside', pattern: MetalsTaskStylePattern.Dotted },
    [MetalsTaskType.Transfer]: { colorVar: '--color-6', iconName: 'delivery_truck', pattern: MetalsTaskStylePattern.Dotted },
};



